import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import Tools from './pages/Tools';
import News from './pages/News';
import Blog from './pages/Blog';
import Quant from './pages/Quant';
import Code from './pages/Code';
import Game from './pages/Game';
import './index.scss';

const tabConfigs = [
  {
    path: '/news',
    label: '资讯',
  },
  {
    path: '/tools',
    label: '小工具',
  },
  {
    path: '/blog',
    label: '博客',
  },
  {
    path: '/quant',
    label: '量化',
  },
  {
    path: '/code',
    label: '代码案例',
  },
  {
    path: '/game',
    label: '小游戏',
  }
];

// 导航栏组件
function NavBar() {
  const location = useLocation();
  const currentPath = location.pathname.split('/')[1] || 'tools';
  
  return (
            <div className="hacker-navbar" style={{ padding: '16px 0', position: 'fixed', top: 0, left: 0, width: '100vw', zIndex: 100, height: '60px', overflow: 'hidden' }}>
          <div className="navbar-scroll-container" style={{ display: 'flex', alignItems: 'center', maxWidth: 1200, margin: '0 auto', padding: '0 24px', overflowX: 'auto', height: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'center', minWidth: 'max-content', flexWrap: 'nowrap', whiteSpace: 'nowrap' }}>
          {tabConfigs.map(tab => {
            const isActive = currentPath === tab.path.substring(1);
            return (
              <Link
                key={tab.path}
                to={tab.path}
                className={`hacker-navbar-link ${isActive ? 'active' : ''}`}
              >
                {tab.label}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      {/* 全局黑客风格样式已提取到 index.scss */}
      <NavBar />
      <div className="hacker-main" style={{ marginTop: 72 }}>
        <Routes>
          <Route path="/tools/:sub?" element={<Tools />} />
          <Route path="/news/:sub?" element={<News />} />
          <Route path="/blog/:sub?" element={<Blog />} />
          <Route path="/blog/article/:id" element={<Blog />} />
          <Route path="/quant/:sub?" element={<Quant />} />
          <Route path="/code/:sub?" element={<Code />} />
          <Route path="/game/:sub?" element={<Game />} />
          <Route path="*" element={<Navigate to="/tools" replace />} />
        </Routes>
      </div>
    </Router>
  );
} 